import { render, staticRenderFns } from "./LeadNotFound.vue?vue&type=template&id=fa3ea20a&"
import script from "./LeadNotFound.vue?vue&type=script&lang=js&"
export * from "./LeadNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports